import {
  AreaOfInterestEntity,
  AreaOfInterestEnum,
  DetectionConfigEntity,
  DetectionTypeEnum,
  IMonitoringRepository,
  LayerValueObject,
  OfficialSourceEntity,
  OfficialSourceEnum,
  ResponseValueObject,
  SatelliteOrbitEnum,
  TerritorialCategoryEntity,
  TerritorialCategoryEnum,
} from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class MonitoringRepository implements IMonitoringRepository {
  async getMonitoringLayers(): Promise<ResponseValueObject<LayerValueObject>> {
    const response = await axiosClient.get<ResponseValueObject<LayerValueObject>>('/layers/monitoring');
    return response.data;
  }

  async getAreasOfInterest(): Promise<ResponseValueObject<AreaOfInterestEntity[]>> {
    return new ResponseValueObject(true, [
      { id: 'authorization-title',  name: 'Título habilitante',     type: AreaOfInterestEnum.AuthorizationTitle,  withValue: true  },
      { id: 'management-plan',      name: 'Plan de manejo',         type: AreaOfInterestEnum.ManagementPlan,      withValue: true  },
      { id: 'conservation-plan',    name: 'Plan de conservación',   type: AreaOfInterestEnum.ConservationPlan,    withValue: true  },
      { id: 'coordinates',          name: 'Coordenadas',            type: AreaOfInterestEnum.Coordinates,         withValue: true  },
      { id: 'shapefile',            name: 'Shapefile',              type: AreaOfInterestEnum.Shapefile,           withValue: false },
      { id: 'geojson',              name: 'GeoJSON',                type: AreaOfInterestEnum.GeoJson,             withValue: false },
      { id: 'draw-polygon',         name: 'Dibujar polígono',       type: AreaOfInterestEnum.DrawPolygon,         withValue: false },
    ]);
  }

  async getTerritorialCategories(): Promise<ResponseValueObject<TerritorialCategoryEntity[]>> {
    return new ResponseValueObject(true, [
      { id: 'reserves', name: 'Reservas', type: TerritorialCategoryEnum.Reserves, selected: true },
      { id: 'protected-natural-areas', name: 'Áreas natural protegida', type: TerritorialCategoryEnum.ProtectedNaturalAreas, selected: true },
      { id: 'regional-conservation-areas', name: 'Áreas de conservación regional', type: TerritorialCategoryEnum.RegionalConservationAreas, selected: false },
      { id: 'private-conservation-areas', name: 'Áreas de conservación privada', type: TerritorialCategoryEnum.PrivateConservationAreas, selected: false },
      { id: 'buffer-zone', name: 'Zona de amortiguamiento', type: TerritorialCategoryEnum.BufferZone, selected: false },
      { id: 'permanent-production-forests', name: 'Bosques de producción permanente', type: TerritorialCategoryEnum.PermanentProductionForests, selected: false },
      { id: 'artisanal-mining', name: 'Zona de pequeña minería y minería artesanal - D.Leg N° 1100', type: TerritorialCategoryEnum.ArtisanalMining, selected: false },
    ]);
  }

  async getOfficialSources(): Promise<ResponseValueObject<OfficialSourceEntity[]>> {
    return new ResponseValueObject(true, [
      { id: 'sernanp',          name: 'SERNANP',                      type: OfficialSourceEnum.Sernanp,         selected: false },
      { id: 'minam',            name: 'MINAM',                        type: OfficialSourceEnum.Minam,           selected: false },
      { id: 'midagri',          name: 'MIDAGRI',                      type: OfficialSourceEnum.Midagri,         selected: false },
      { id: 'osinfor',          name: 'OSINFOR',                      type: OfficialSourceEnum.Osinfor,         selected: true  },
      { id: 'amazonia-osinfor', name: 'Amazonía OSINFOR',             type: OfficialSourceEnum.AmazoniaOsinfor, selected: false },
      { id: 'minagri',          name: 'MINAGRI',                      type: OfficialSourceEnum.Minagri,         selected: false },
      { id: 'geobosques',       name: 'Geobosques (MINAM/PNCBMCC)',   type: OfficialSourceEnum.Geobosques,      selected: false },
    ]);
  }

  async getDetections(): Promise<ResponseValueObject<DetectionConfigEntity[]>> {

    return new ResponseValueObject(true, [
      new DetectionConfigEntity({
        type: DetectionTypeEnum.Radar,
        period: { start: '2026-08-05', end: '2026-08-03' },
        orbit: SatelliteOrbitEnum.Sentinel1AAscending,
        forestMapYear: 2013,
        forestCoveragePercent: 75,
        orbitOptions: [
          SatelliteOrbitEnum.Sentinel1AAscending,
          SatelliteOrbitEnum.Sentinel1ADescending,
          SatelliteOrbitEnum.Sentinel1BAscending,
        ],
      }),
      new DetectionConfigEntity({
        type: DetectionTypeEnum.Optical,
        period: { start: '2026-08-05', end: '2026-08-19' },
        orbit: SatelliteOrbitEnum.Sentinel2B,
        forestMapYear: 2019,
        forestCoveragePercent: 75,
        orbitOptions: [
          SatelliteOrbitEnum.Sentinel2A,
          SatelliteOrbitEnum.Sentinel2B,
          SatelliteOrbitEnum.Landsat8,
        ],
      }),
    ]);
  }
}
